import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { GET, POST, httpOk } from 'helpers/api'
import { formatDate } from 'helpers/helpers'

// Ishlab chiqarish rahbari EGAGA hisobot topshiradi.
// Dastur bo'lim raqamlarini ko'rsatadi -> rahbar izoh yozib topshiradi (snapshot saqlanadi).
function Report() {
	const { t } = useTranslation()

	const [departments, setDepartments] = useState([])
	const [myReports, setMyReports] = useState([])
	const [form, setForm] = useState({
		period_type: 'daily',
		report_date: formatDate(new Date(), 'yyyy-MM-dd'),
		note: '',
	})
	const [saving, setSaving] = useState(false)

	async function loadDashboard() {
		const res = await GET('/workshop-dashboard', {}, { loader: false })
		if (httpOk(res)) setDepartments(res.data.departments || [])
	}

	async function loadMy() {
		const res = await GET('/manager-reports/my', {}, { loader: false })
		if (httpOk(res)) setMyReports(res.data.data || [])
	}

	useEffect(() => { loadDashboard(); loadMy() }, [])

	async function submit(e) {
		e.preventDefault()
		setSaving(true)
		// Topshirish paytidagi bo'lim raqamlari — snapshot sifatida saqlanadi
		const metrics = departments.map((d) => ({
			name: d.name, active_orders: d.active_orders, late: d.late, volume: d.volume,
		}))
		const res = await POST('/manager-reports', { ...form, metrics }, { loader: true })
		setSaving(false)
		if (httpOk(res)) {
			setForm({ ...form, note: '' })
			loadMy()
		}
	}

	const periodLabel = (p) => (p === 'shift' ? t('period_shift') : p === 'weekly' ? t('period_weekly') : t('period_daily'))

	return (
		<>
			<div className="page-header">
				<h4 className="mb-0">{t('submit_report')}</h4>
			</div>

			<div className="row g-3">
				{/* CHAP: topshirish formasi */}
				<div className="col-lg-6">
					<div className="card">
						<div className="card-body">
							<form onSubmit={submit} autoComplete="off">
								<div className="row">
									<div className="col-6">
										<div className="form-group">
											<label>{t('report_period')}</label>
											<select className="form-select" value={form.period_type}
												onChange={(e) => setForm({ ...form, period_type: e.target.value })}>
												<option value="daily">{t('period_daily')}</option>
												<option value="shift">{t('period_shift')}</option>
												<option value="weekly">{t('period_weekly')}</option>
											</select>
										</div>
									</div>
									<div className="col-6">
										<div className="form-group">
											<label>{t('date')}</label>
											<input type="date" className="form-control" value={form.report_date}
												onChange={(e) => setForm({ ...form, report_date: e.target.value })} />
										</div>
									</div>
								</div>

								{/* Bo'lim raqamlari — o'zgarmas snapshot ko'rinishi */}
								<div className="border rounded p-2 mb-3" style={{ background: '#f8f9fa' }}>
									<div className="small text-muted mb-1">{t('snapshot_note')}</div>
									{departments.length === 0
										? <div className="text-muted small">—</div>
										: departments.map((d) => (
											<div key={d.product_type} className="d-flex justify-content-between small py-1"
												style={{ borderBottom: '1px solid #eee' }}>
												<span className="fw-600">{d.name}</span>
												<span>
													{t('active_orders')}: <b>{d.active_orders}</b>
													{d.late > 0 && <span className="text-danger ms-2">{t('late_orders')}: {d.late}</span>}
												</span>
											</div>
										))
									}
								</div>

								<div className="form-group">
									<label>{t('report_note')}<span className="required-mark">*</span></label>
									<textarea className="form-control" rows={4} value={form.note}
										placeholder={t('report_note_ph')}
										onChange={(e) => setForm({ ...form, note: e.target.value })} />
								</div>

								<button type="submit" className="btn btn-primary w-100"
									disabled={saving || !form.note.trim()}>
									<i className="uil-message me-1"></i>{t('submit_report')}
								</button>
							</form>
						</div>
					</div>
				</div>

				{/* O'NG: mening hisobotlarim */}
				<div className="col-lg-6">
					<div className="card">
						<div className="card-body">
							<h6 className="fw-bold mb-3">{t('my_reports')}</h6>
							{myReports.length === 0
								? <div className="text-muted small py-3 text-center">{t('list_empty')}</div>
								: <div className="d-flex flex-column gap-2" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
									{myReports.map((r) => (
										<div key={r.id} className="border rounded p-2">
											<div className="d-flex justify-content-between align-items-center mb-1">
												<span className="small">
													<span className="badge bg-light text-dark me-1">{periodLabel(r.period_type)}</span>
													{formatDate(r.report_date, 'dd.MM.yyyy')}
												</span>
												{Number(r.status) === 2
													? <span className="badge bg-success">{t('status_reviewed')}</span>
													: <span className="badge bg-warning text-dark">{t('status_submitted')}</span>}
											</div>
											<div className="small" style={{ whiteSpace: 'pre-wrap' }}>{r.note}</div>
											{r.owner_note &&
												<div className="mt-1 p-1 rounded small" style={{ background: '#e8f0fe' }}>
													<b>{t('owner_note')}:</b> {r.owner_note}
												</div>
											}
										</div>
									))}
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Report
